import { cryptoTokens, LinkProps, LinkStyles } from '@pijma/hero-types'

type LinkStyleOptsFactory = LinkStyles<cryptoTokens>

const getColor = (props: LinkProps, common: cryptoTokens) => {
  if (props.disabled) {
    return { color: common.color.font.light_bg.primary.disabled.color }
  }
  return {
    color: common.color.font.link.default.color,
    '&:hover, &:active': {
      color: common.color.font.link.hover.color,
    },
  }
}
const getFont = (props: LinkProps, common: cryptoTokens) => {
  return props.font || common.text.body[500].default.typography
}

export const LinkStylesCryptoFactory: LinkStyleOptsFactory = (common) => ({
  styleProvider: {
    root: (props) => {
      return {
        textDecoration: 'none',
        ...getFont(props, common),
        ...getColor(props, common),
        cursor: props.disabled ? 'default' : 'pointer',
        pointerEvents: props.disabled ? 'none' : 'auto',
        transition: `all ${common.animation.s.animation}`,
      }
    },
  },
})
